import { typography, borderRadius, cssSpacing } from "../app/design-system";
import type { ListColumn } from "../../../../../shared/frontend/list/listColumn";
import { Spin,Typography } from "../../../../../shared/frontend/ui";
import React from "react";
import { spacing } from "../app/design-system";
import type { DrawerItemsTableSelection } from "./DrawerItemsTable";
import { DrawerItemsTable } from "./DrawerItemsTable";

const SCROLL_Y = 280;

export type DrawerSelectionListProps<T extends object> = {
  /** Titel über der Liste (einheitliche Darstellung in allen Drawern) */
  title: React.ReactNode;
  /** Daten für die Tabelle */
  dataSource: T[];
  /** Spaltendefinitionen */
  columns: ListColumn<T>[];
  /** Zeilenschlüssel (z. B. "id") */
  rowKey: keyof T | string;
  /** Zeilenauswahl (Checkboxen) */
  rowSelection?: DrawerItemsTableSelection<T>;
  /** Text bei leerer dataSource */
  emptyText?: React.ReactNode;
  /** Ladezustand – zeigt Spinner in gleicher Höhe wie die Tabelle, kein Layout-Sprung */
  loading?: boolean;
  /** Mindestbreite der Desktop-Tabelle, damit kompakte Drawer-Spalten stabil bleiben. */
  scrollX?: number | string;
};

/**
 * Einheitliche „Liste + Titel mit Auswahl“ für Drawer (Zahlung erfassen, Stornierung).
 * Immer gleiches Layout, feste Scroll-Höhe, gleiches Design.
 */
export function DrawerSelectionList<T extends object>({
  title,
  dataSource,
  columns,
  rowKey,
  rowSelection,
  emptyText,
  loading = false,
  scrollX
}: DrawerSelectionListProps<T>): React.ReactElement {
  return (
    <div className="drawer-selection-list" style={{ marginBottom: spacing.xl }}>
      <div style={{ marginBottom: spacing.sm }}>
        <Typography.Text strong style={{ fontSize: typography.fontSize.base }}>
          {title}
        </Typography.Text>
      </div>
      {loading ? (
        <div
          style={{
            minHeight: SCROLL_Y,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid var(--ant-color-border-secondary, #f0f0f0)",
            borderRadius: borderRadius.md
          }}
        >
          <Spin size="small" />
        </div>
      ) : dataSource.length === 0 && emptyText != null ? (
        <div
          style={{
            minHeight: 80,
            display: "flex",
            alignItems: "center",
            padding: cssSpacing(spacing.md, 0),
            borderRadius: borderRadius.md
          }}
        >
          {emptyText}
        </div>
      ) : (
        <div
          className="drawer-selection-list-table-wrap"
          style={{
            border: "1px solid var(--ant-color-border-secondary, #f0f0f0)",
            borderRadius: borderRadius.md,
            overflow: "hidden"
          }}
        >
          <DrawerItemsTable<T>
            dataSource={dataSource}
            columns={columns}
            rowKey={rowKey}
            scrollY={SCROLL_Y}
            scrollX={scrollX}
            emptyText={emptyText}
            rowSelection={rowSelection}
          />
        </div>
      )}
    </div>
  );
}
